import { Icon } from "@components";

import selectors from "../selectors";

interface Props {
  title: string | null;
  body: string[] | null;
}

export default function PremiumShippingMessage({ title, body }: Props) {
  if (!title) return null;

  return (
    <div data-testid={selectors.premiumShipping.title} className="mb-5 lg:mb-0">
      <div className="flex gap-2">
        <Icon
          name="white-glove"
          size="full"
          className="h-6 w-6 shrink-0 relative -top-0.5"
        />
        <p>{title}</p>
      </div>
      {body && body.length > 0 && (
        <ul
          data-testid={selectors.premiumShipping.body}
          className="pl-8 mt-2.5 flex flex-col gap-2.5"
        >
          {body.map((text) => (
            <li key={text} className="flex gap-2">
              <Icon
                name="checkmark"
                size="full"
                className="relative h-3 w-[18px] shrink-0 top-1"
              />
              <p>{text}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
